import Box, { BoxProps } from "ds/components/Box";
import MainNavigationNavigationItem from "components/MainNavigation/components/elements/NavigationItem";
import { MainNavigationItem } from "components/MainNavigation/types";

type MainNavigationListItemsProps = {
  items: MainNavigationItem[];
  padding?: BoxProps["padding"];
};

const MainNavigationListItems = ({
  items,
  padding = "medium 0 0",
}: MainNavigationListItemsProps) => {
  return (
    <Box direction="column" gap="medium" align="start" padding={padding}>
      {items.map((item) => (
        <MainNavigationNavigationItem key={item.id} item={item} />
      ))}
    </Box>
  );
};

export default MainNavigationListItems;
